import React, { Component, Fragment } from 'react';
import Store from 'eas-react-store';
import Header from '../layout/Header/Header';
import { URI } from '../../URI';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

class OrganisationSettings extends Component {
    constructor(props) {
        super(props);
        
        const organisation = this.props.store.User.data.organisation;
        
        this.state = {
            first_weekday: organisation?.first_weekday || 1,
            isEditMode: false,
            saving: false,
            saveSuccess: false,
            saveError: false,
            dropdownOpen: false
        };
        
        this.options = [
            { value: '1', label: 'Måndag' },
            { value: '2', label: 'Tisdag' },
            { value: '3', label: 'Onsdag' },
            { value: '4', label: 'Torsdag' },
            { value: '5', label: 'Fredag' },
            { value: '6', label: 'Lördag' },
            { value: '7', label: 'Söndag' }
        ];
        
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onDropdownChange = this.onDropdownChange.bind(this);
        this.onDropdownOpen = this.onDropdownOpen.bind(this);
        this.onDropdownClose = this.onDropdownClose.bind(this);
        this.saveSettings = this.saveSettings.bind(this);
        this.toggleEditMode = this.toggleEditMode.bind(this);
        this.handleClickOnCancel = this.handleClickOnCancel.bind(this);
        
        this._isMounted = false;
    }
    
    componentDidMount() {
        this._isMounted = true;
    }
    
    componentWillUnmount() {
        this._isMounted = false;
    }
    
    handleInputChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: parseInt(value),
            saveSuccess: false,
            saveError: false
        });
    }
    
    onDropdownChange(selectedOption) {
        this.setState({
            first_weekday: parseInt(selectedOption.value),
            saveSuccess: false,
            saveError: false,
            dropdownOpen: false
        });
    }
    
    onDropdownOpen() {
        this.setState({ dropdownOpen: true });
    }
    
    onDropdownClose() {
        this.setState({ dropdownOpen: false });
    }
    
    toggleEditMode() {
        const organisation = this.props.store.User.data.organisation;
        this.setState(prevState => ({
            isEditMode: !prevState.isEditMode,
            first_weekday: organisation?.first_weekday || 1,
            dropdownOpen: false
        }));
    }
    
    handleClickOnCancel() {
        const organisation = this.props.store.User.data.organisation;
        this.setState({
            isEditMode: false,
            first_weekday: organisation?.first_weekday || 1,
            saveSuccess: false,
            saveError: false,
            dropdownOpen: false
        });
    }
    
    componentDidUpdate(prevProps) {
        if (!this.state.isEditMode) {
            const organisation = this.props.store.User.data.organisation;
            const prevOrganisation = prevProps.store.User.data.organisation;
            
            if (organisation && 
                (!prevOrganisation || organisation.first_weekday !== prevOrganisation.first_weekday)) {
                const newFirstWeekday = organisation.first_weekday || 1;
                if (this.state.first_weekday !== newFirstWeekday && this._isMounted) {
                    this.setState({ first_weekday: newFirstWeekday });
                }
            }
        }
    }
    
    async saveSettings(e) {
        if (e) e.preventDefault();
        
        this.setState({ saving: true, saveSuccess: false, saveError: false });
        
        try {
            const payload = { first_weekday: this.state.first_weekday };
            const updatedOrganisation = await this.props.store.User.updateOrganisationSettings(payload);
            
            const newFirstWeekday = updatedOrganisation?.first_weekday !== undefined 
                ? updatedOrganisation.first_weekday 
                : (this.props.store.User.data.organisation?.first_weekday !== undefined
                    ? this.props.store.User.data.organisation.first_weekday
                    : this.state.first_weekday);
            
            if (this._isMounted) {
                this.setState({ 
                    saving: false,
                    saveSuccess: true,
                    isEditMode: false,
                    dropdownOpen: false,
                    first_weekday: newFirstWeekday
                });
            }
        } catch (error) {
            console.error('Error saving organization settings:', error);
            if (this._isMounted) {
                this.setState({ saving: false, saveError: true });
            }
        }
    }
    
    getFirstDayOfWeekText(value) {
        switch(value) {
            case 1:
                return "Måndag";
            case 2:
                return "Tisdag";
            case 3:
                return "Onsdag";
            case 4:
                return "Torsdag";
            case 5:
                return "Fredag";
            case 6:
                return "Lördag";
            case 7:
                return "Söndag";
            default:
                return "Måndag";
        }
    }
    
    render() {
        const { first_weekday, isEditMode, saving, saveSuccess, saveError, dropdownOpen } = this.state;
        let rowClassName = isEditMode ? "category-row edit-mode" : "category-row";
        
        const selectedOption = this.options.find(option => parseInt(option.value) === first_weekday) || this.options[0];
        
        return (
            <Fragment>
                <Header
                    current={URI.admin.organisationSettings}
                    currentRoot={URI.admin.root}
                />
                <div className="container content-container organisation-settings">
                    <div className="category-table-header mb-3">
                        <h1>Organisationsinställningar</h1>
                    </div>
                    
                    {saveSuccess && (
                        <div className="alert alert-success mb-3" role="alert">
                            Inställningarna har sparats!
                        </div>
                    )}
                    
                    {saveError && (
                        <div className="alert alert-danger mb-3" role="alert">
                            Det gick inte att spara inställningarna. Vänligen försök igen.
                        </div>
                    )}
                    
                    <table className="categories-table">
                        <thead>
                            <tr>
                                <th>Inställning</th>
                                <th>Värde</th>
                                <th className="cell-right">Åtgärd</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className={rowClassName}>
                                <td>
                                    <span>Första dag i veckan</span>
                                </td>
                                <td>
                                    <span className="category-title">
                                        {this.getFirstDayOfWeekText(first_weekday)}
                                    </span>
                                    <div className="edit-input dropdown-wrapper">
                                        <Dropdown
                                            options={this.options}
                                            onChange={this.onDropdownChange}
                                            onOpen={this.onDropdownOpen}
                                            onClose={this.onDropdownClose}
                                            value={selectedOption}
                                            placeholder="Välj första dag i veckan"
                                            className={dropdownOpen ? "dropdown-open" : ""}
                                        />
                                    </div>
                                </td>
                                <td className="cell-right">
                                    <div className="table-action">
                                        <span 
                                            className="table-action-edit"
                                            onClick={this.toggleEditMode}>
                                                Redigera
                                        </span>
                                    </div>
                                    <div className="btn-wrapper">
                                        <button className="btn btn-table-small btn-cancel" onClick={this.handleClickOnCancel}>Avbryt</button>
                                        <button 
                                            className="btn btn-table-small btn-save" 
                                            onClick={this.saveSettings}
                                            disabled={saving}
                                        >
                                            {saving ? 'Sparar...' : 'Spara'}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Fragment>
        );
    }
}

export default Store.connectStore(OrganisationSettings);
